/* eslint-disable */
/* tslint:disable */

/** updateInstitutionPricingPlanSubscription
 * method: put
 * summary: Update institution pricing plan subscription
 */

import type {
  UpdateInstitutionPricingPlanSubscriptionBodyDto,
  GeneralOkNotOkResultDto,
  ApiResponseDto,
} from './../api-types'

export const getPath = (idInstitution: number): string =>
  `/bff-worker/institution/${idInstitution}/update-pricing-plan-subscription`
export const getFullPath = (idInstitution: number): string =>
  `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/institution/${idInstitution}/update-pricing-plan-subscription`

export type RequestBody = UpdateInstitutionPricingPlanSubscriptionBodyDto

export type UpdateInstitutionPricingPlanSubscriptionSuccess =
  GeneralOkNotOkResultDto
export type UpdateInstitutionPricingPlanSubscriptionError = ApiResponseDto
